// extracted by mini-css-extract-plugin
export default {"noFormatText":"GadgetFormatTable_noFormatText__0-8ih","headerText":"GadgetFormatTable_headerText__Ne+n4"};